import { Box, Text } from '@fozito/common-ui';
import React, { CSSProperties, forwardRef, useImperativeHandle, useRef } from 'react';
import ReactSignatureCanvas from 'react-signature-canvas';
import styled from 'styled-components';
type Props = {
  onChange?: (dataUrl: string) => void;
  value?: string;
  style?: CSSProperties;
  ratio?: number;
};
export type CheckSignatureRef = {
  setValue: (val: string) => void;
  clear: () => void;
};
export const useCheckSignature = () => useRef<CheckSignatureRef>(null);
const CheckSignature = forwardRef<CheckSignatureRef, Props>(({ style, onChange: onSignatureChange = () => undefined, ratio = 1 }, ref) => {
  const signRef = useRef<ReactSignatureCanvas>(null);

  const getRatio = (val: number) => ratio * val;

  const handleClear = () => {
    onSignatureChange('');
    signRef.current?.clear();
  };

  useImperativeHandle(ref, () => ({
    setValue: (val: string) => {
      signRef.current?.fromDataURL(val || '', { height: getRatio(250), width: getRatio(650) });
    },
    clear: handleClear,
  }));

  return (
    <Container style={style}>
      <div className="signature-area" >
        <ReactSignatureCanvas ref={signRef}
          canvasProps={{
            width: getRatio(650),
            height: getRatio(250),
            className: 'sigCanvas',
          }}
          onEnd={(event: MouseEvent) => {
            const element = event?.target as HTMLCanvasElement;
            if (element?.toDataURL)
              onSignatureChange(element?.toDataURL() || '');
          }}
        />
      </div>
      <Box display='flex' justifyContent='space-between' alignSelf='stretch' borderBottom={'1px solid #86909C'}>
        <Text className='prevent-select' title_h4_24_medium >Sign here X</Text>
        <button onClick={handleClear} style={{ alignSelf: 'flex-end', opacity: 0 }} type='button'>Close</button>
      </Box>
      <Text className="signature-description prevent-select">
        Cardholder agrees to pay the card issuer the amount of service above, <br /> and it can not dispute or refundable.
      </Text>
    </Container>
  );
});
CheckSignature.displayName = 'CheckSignature';
export default CheckSignature;
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-self: flex-end;
  padding: 0 24px;
  padding-bottom: 40px;
  .signature-description {
    color: #64748B;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
  }
`;